(function ($) {
    'use strict';

    class GalleryCarousal extends HTMLElement {
        constructor() {
            super();

            setTimeout(() => {
                theme.AssetsLoader.onScrollOrUserAction(this, () => {
                    this.load();
                });
            }, 0);
        }

        load() {
            this.$container = $(this);

            var _ = this,
                $carousel = this.$container.find('.feat-gallery-carousel'),
                $slick = $carousel.find('.gallery-slides');

            if ($slick.length) {
                theme.AssetsLoader.loadManually([
                    ['styles', 'plugin_slick'],
                    ['scripts', 'plugin_slick']
                ],
                    function () {
                        _.initSlick($carousel, $slick);
                        _.$container.trigger('section:loaded');
                        _.$container[0].dispatchEvent(new Event('section:loaded'));
                    });
            }

        }

        initSlick($carousel, $slick) {
            var _ = this;
            _.$slick = $slick;

            $slick.one('init', function () {
                $carousel.removeClass('invisible');
                theme.Preloader.unset($carousel.parent());
            });

            //$prev = '<i><svg aria - hidden="true" focusable = "false" role = "presentation" class="icon icon-theme-006" viewBox = "0 0 24 24"><g><path d="M16.736,3.417c0,0.169-0.059,0.319-0.176,0.449l-8.32,8.301l8.32,8.301c0.117,0.13,0.176,0.28,0.176,0.449s-0.059,0.319-0.176,0.449c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.149-0.075-0.215-0.127l-8.75-8.75c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449l8.75-8.75c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176C16.677,3.098,16.736,3.248,16.736,3.417z"></path></g></svg></i>';
            //$next = '<i><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24"><g><path d="M6.708,20.917c0-0.169,0.059-0.319,0.176-0.449l8.32-8.301l-8.32-8.301c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449c0.13-0.117,0.279-0.176,0.449-0.176c0.169,0,0.318,0.059,0.449,0.176l8.75,8.75c0.117,0.13,0.176,0.28,0.176,0.449c0,0.169-0.059,0.319-0.176,0.449l-8.75,8.75c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.15-0.075-0.215-0.127C6.767,21.236,6.708,21.086,6.708,20.917z"></path></g></svg></i>';

            $slick.slick({
                infinite: false,
                autoplay: false,
                prevArrow: '<button class="slide-arrow prev-arrow"><i><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-006" viewBox="0 0 24 24"><g><path d="M16.736,3.417c0,0.169-0.059,0.319-0.176,0.449l-8.32,8.301l8.32,8.301c0.117,0.13,0.176,0.28,0.176,0.449s-0.059,0.319-0.176,0.449c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.149-0.075-0.215-0.127l-8.75-8.75c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449l8.75-8.75c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176C16.677,3.098,16.736,3.248,16.736,3.417z"></path></g></svg></i></button>',
                nextArrow: '<button class="slide-arrow next-arrow"><i><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24"><g><path d="M6.708,20.917c0-0.169,0.059-0.319,0.176-0.449l8.32-8.301l-8.32-8.301c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449c0.13-0.117,0.279-0.176,0.449-0.176c0.169,0,0.318,0.059,0.449,0.176l8.75,8.75c0.117,0.13,0.176,0.28,0.176,0.449c0,0.169-0.059,0.319-0.176,0.449l-8.75,8.75c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.15-0.075-0.215-0.127C6.767,21.236,6.708,21.086,6.708,20.917z"></path></g></svg></i></button>',
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 980,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                  {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            centerPadding: '40px',
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        };

        disconnectedCallback() {
            if (this.$slick) {
                this.$slick.slick('destroy').off();
                $window.unbind('load.slickResize');
                this.$slick = null;
            }
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('gallery-carousal', GalleryCarousal);
    });
})(jQueryTheme);

(function ($) {
    'use strict';

    class FeaturedCollections extends HTMLElement {
        constructor() {
            super();

            setTimeout(() => {
                theme.AssetsLoader.onScrollOrUserAction(this, () => {
                    this.load();
                });
            }, 0);
        }

        load() {
            this.$container = $(this);

            var _ = this,
                $carousel = this.$container.find('.feat-collection-carousel'),
                $slick = $carousel.find('.collection-slides');

            if ($slick.length) {
                theme.AssetsLoader.loadManually([
                    ['styles', 'plugin_slick'],
                    ['scripts', 'plugin_slick']
                ],
                    function () {
                        _.initSlick($carousel, $slick);
                        _.$container.trigger('section:loaded');
                        _.$container[0].dispatchEvent(new Event('section:loaded'));
                    });
            }

        }

        initSlick($carousel, $slick) {
            var _ = this;
            _.$slick = $slick;

            $slick.one('init', function () {
                $carousel.removeClass('invisible');
                theme.Preloader.unset($carousel.parent());
            });

            //$prev = '<i><svg aria - hidden="true" focusable = "false" role = "presentation" class="icon icon-theme-006" viewBox = "0 0 24 24"><g><path d="M16.736,3.417c0,0.169-0.059,0.319-0.176,0.449l-8.32,8.301l8.32,8.301c0.117,0.13,0.176,0.28,0.176,0.449s-0.059,0.319-0.176,0.449c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.149-0.075-0.215-0.127l-8.75-8.75c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449l8.75-8.75c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176C16.677,3.098,16.736,3.248,16.736,3.417z"></path></g></svg></i>';
            //$next = '<i><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24"><g><path d="M6.708,20.917c0-0.169,0.059-0.319,0.176-0.449l8.32-8.301l-8.32-8.301c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449c0.13-0.117,0.279-0.176,0.449-0.176c0.169,0,0.318,0.059,0.449,0.176l8.75,8.75c0.117,0.13,0.176,0.28,0.176,0.449c0,0.169-0.059,0.319-0.176,0.449l-8.75,8.75c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.15-0.075-0.215-0.127C6.767,21.236,6.708,21.086,6.708,20.917z"></path></g></svg></i>';

            $slick.slick({
                infinite: false,
                autoplay: false,
                prevArrow: '<button class="slide-arrow prev-arrow"><i><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-006" viewBox="0 0 24 24"><g><path d="M16.736,3.417c0,0.169-0.059,0.319-0.176,0.449l-8.32,8.301l8.32,8.301c0.117,0.13,0.176,0.28,0.176,0.449s-0.059,0.319-0.176,0.449c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.149-0.075-0.215-0.127l-8.75-8.75c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449l8.75-8.75c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176C16.677,3.098,16.736,3.248,16.736,3.417z"></path></g></svg></i></button>',
                nextArrow: '<button class="slide-arrow next-arrow"><i><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24"><g><path d="M6.708,20.917c0-0.169,0.059-0.319,0.176-0.449l8.32-8.301l-8.32-8.301c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449c0.13-0.117,0.279-0.176,0.449-0.176c0.169,0,0.318,0.059,0.449,0.176l8.75,8.75c0.117,0.13,0.176,0.28,0.176,0.449c0,0.169-0.059,0.319-0.176,0.449l-8.75,8.75c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.15-0.075-0.215-0.127C6.767,21.236,6.708,21.086,6.708,20.917z"></path></g></svg></i></button>',
                slidesToShow: 9,
                slidesToScroll: 9,
                responsive: [
                    {
                        breakpoint: 980,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5
                        }
                    },
                  {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            centerPadding: '40px',
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ]
            });
        };

        disconnectedCallback() {
            if (this.$slick) {
                this.$slick.slick('destroy').off();
                $window.unbind('load.slickResize');
                this.$slick = null;
            }
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('featured-collections', FeaturedCollections);
    });
})(jQueryTheme);

(function ($) {
    'use strict';

    class HeaderAnnouncement extends HTMLElement {
        constructor() {
            super();

            setTimeout(() => {
                theme.AssetsLoader.onScrollOrUserAction(this, () => {
                    this.load();
                });
            }, 0);
        }

        load() {
            this.$container = $(this);

            var _ = this,
                $carousel = this.$container.find('.announcement__slider'),
                $slick = $carousel.find('.h_slider__items');

            if ($slick.length) {
                theme.AssetsLoader.loadManually([
                    ['styles', 'plugin_slick'],
                    ['scripts', 'plugin_slick']
                ],
                    function () {
                        _.initSlick($carousel, $slick);
                        _.$container.trigger('section:loaded');
                        _.$container[0].dispatchEvent(new Event('section:loaded'));
                    });
            }

        }

        initSlick($carousel, $slick) {
            var _ = this;
            _.$slick = $slick;

            $slick.one('init', function () {
                $carousel.removeClass('invisible');
                theme.Preloader.unset($carousel.parent());
            });

            $slick.slick({
                infinite: true,
                autoplay: true,
                prevArrow: false,
                nextArrow: false,
                autoplaySpeed: 2000,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
        };

        disconnectedCallback() {
            if (this.$slick) {
                this.$slick.slick('destroy').off();
                $window.unbind('load.slickResize');
                this.$slick = null;
            }
        }
    }

    theme.AssetsLoader.onPageLoaded(function () {
        customElements.define('header-announcement', HeaderAnnouncement);
    });
})(jQueryTheme);